var _defs, _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g4, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.478,
    height: 117.124,
    viewBox: "0 0 120.478 117.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24439",
    "data-name": "Rectangle 24439",
    width: 100,
    height: 117.124,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b5f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54356a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66138",
    "data-name": "Path 66138",
    d: "M22.072,49.177l.266.155a.4.4,0,0,0-.4.039l-.266-.155a.508.508,0,0,1,.252-.077.3.3,0,0,1,.15.038",
    transform: "translate(-21.67 -49.139)",
    fill: "#a97f7f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66144",
    "data-name": "Path 66144",
    d: "M23.676,49.779a1.247,1.247,0,0,0-.564.976l-.266-.155a1.247,1.247,0,0,1,.564-.976Z",
    transform: "translate(-22.846 -49.624)",
    fill: "#a97f7f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5eff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2b1ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27165",
    "data-name": "Rectangle 27165",
    width: 28.537,
    height: 69.829,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27161",
    "data-name": "Rectangle 27161",
    width: 7.684,
    height: 5.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27162",
    "data-name": "Rectangle 27162",
    width: 4.563,
    height: 2.902,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27163",
    "data-name": "Rectangle 27163",
    width: 1.747,
    height: 0.724,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Manage_Users",
    "data-name": "Manage Users",
    transform: "translate(-1338.522 -758.742)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67621",
    "data-name": "Group 67621",
    transform: "translate(1359 758.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67509",
    "data-name": "Group 67509",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64981",
    "data-name": "Group 64981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66102",
    "data-name": "Path 66102",
    d: "M21.339,37.621l2.484-1.443-.2,73.09-2.483,1.443Z",
    transform: "translate(59.317 -7.326)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64903",
    "data-name": "Group 64903",
    transform: "translate(34.416 0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64984",
    "data-name": "Group 64984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66103",
    "data-name": "Path 66103",
    d: "M68.949,27.475a4.274,4.274,0,0,1,1.939,3.358l-.2,73.09c0,1.234-.878,1.732-1.951,1.112L28.129,81.621a4.274,4.274,0,0,1-1.939-3.358l.2-73.09c0-1.234.878-1.732,1.951-1.112Z",
    transform: "translate(-26.19 -1.169)",
    fill: "#fff5e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66104",
    "data-name": "Path 66104",
    d: "M49.038,20.09l5.188,2.995c.2.116.364.022.364-.211a.809.809,0,0,0-.364-.632l-5.188-3c-.2-.116-.365-.021-.365.211a.811.811,0,0,0,.365.632",
    transform: "translate(-27.823 -4.288)",
    fill: "#412428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66105",
    "data-name": "Path 66105",
    d: "M56.992,18.1a1.177,1.177,0,0,0,.532.921c.293.17.532.032.532-.307a1.177,1.177,0,0,0-.532-.921c-.293-.17-.532-.032-.532.307",
    transform: "translate(-37.922 -3.988)",
    fill: "#412428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66106",
    "data-name": "Path 66106",
    d: "M24.8.5l40.61,23.414a4.712,4.712,0,0,1,.721.52,6.479,6.479,0,0,1,1.253,1.508L64.9,27.387a6.5,6.5,0,0,0-1.253-1.508,4.605,4.605,0,0,0-.721-.52L22.313,1.945Z",
    transform: "translate(-19.59 -0.502)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66107",
    "data-name": "Path 66107",
    d: "M21.142,31.3l2.483-1.443A6.409,6.409,0,0,1,26.534,34.9L24.05,36.341A6.407,6.407,0,0,0,21.142,31.3",
    transform: "translate(22.19 -6.447)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66108",
    "data-name": "Path 66108",
    d: "M23.873,129.7l-2.483,1.443a2.043,2.043,0,0,0,.851-1.872l2.483-1.443a2.041,2.041,0,0,1-.851,1.871",
    transform: "translate(23.802 -26.286)",
    fill: "#bfc7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66109",
    "data-name": "Path 66109",
    d: "M23.873,129.7l-2.483,1.443a2.043,2.043,0,0,0,.85-1.872l2.484-1.443a2.042,2.042,0,0,1-.851,1.872",
    transform: "translate(23.802 -26.286)",
    fill: "#5b3439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64910",
    "data-name": "Group 64910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64909",
    "data-name": "Group 64909",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66112",
    "data-name": "Path 66112",
    d: "M75.711,1.641,78.194.2A2.059,2.059,0,0,1,80.27.4L77.787,1.844a2.059,2.059,0,0,0-2.076-.2",
    transform: "translate(-40.649 0)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64912",
    "data-name": "Group 64912",
    transform: "translate(35.062 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73766",
    "data-name": "Group 73766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66113",
    "data-name": "Path 66113",
    d: "M76.857,1.641,79.34.2A1.64,1.64,0,0,1,80.5.041L78.019,1.484a1.636,1.636,0,0,0-1.162.156",
    transform: "translate(-76.857 -0.001)",
    fill: "#5b3439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66114",
    "data-name": "Path 66114",
    d: "M75.71,1.494,78.193.051a2.989,2.989,0,0,1,.915.36L76.625,1.854a3.021,3.021,0,0,0-.915-.36",
    transform: "translate(-74.548 -0.011)",
    fill: "#5b3439"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64914",
    "data-name": "Group 64914",
    transform: "translate(34.013 1.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64983",
    "data-name": "Group 64983",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66116",
    "data-name": "Path 66116",
    d: "M24.454,3.878h0a3.137,3.137,0,0,1,.1-.793,1.656,1.656,0,0,1,.842-1.125,1.776,1.776,0,0,1,1.325-.046,3.276,3.276,0,0,1,.664.3L67.991,25.624a6.493,6.493,0,0,1,2.739,3.8,4.874,4.874,0,0,1,.17,1.242l-.2,73.09a3.381,3.381,0,0,1-.045.557h0a1.837,1.837,0,0,1-.725,1.263h0a2.006,2.006,0,0,1-2.156-.152L27.164,82h0a6.409,6.409,0,0,1-2.908-5.037Zm.2,73.983A4.274,4.274,0,0,0,26.6,81.219l40.61,23.414a1.336,1.336,0,0,0,1.438.1,1.224,1.224,0,0,0,.483-.842,2.185,2.185,0,0,0,.03-.372l.2-73.09a3.234,3.234,0,0,0-.113-.828,4.329,4.329,0,0,0-1.825-2.53L26.808,3.658a2.141,2.141,0,0,0-.442-.2,1.188,1.188,0,0,0-.884.031,1.108,1.108,0,0,0-.562.75,2.137,2.137,0,0,0-.064.528Z",
    transform: "translate(-24.256 -1.809)",
    fill: "#f0dbd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66117",
    "data-name": "Path 66117",
    d: "M70.807,34.3l-.2,70.359a1.7,1.7,0,0,1-.222.9c-.326.53-.979.643-1.729.21L28.049,82.36a2.922,2.922,0,0,1-.425-.3A4.333,4.333,0,0,1,26.109,79l.2-70.357c0-1.234.877-1.732,1.951-1.113L68.869,30.946a4.316,4.316,0,0,1,1.81,2.478,3.215,3.215,0,0,1,.128.879",
    transform: "translate(-25.642 -2.914)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66118",
    "data-name": "Path 66118",
    d: "M23.765,48.15,23.5,48a.4.4,0,0,1-.165-.362l.266.155a.4.4,0,0,0,.165.362",
    transform: "translate(23.613 -11.089)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64916",
    "data-name": "Group 64916",
    transform: "translate(80.96 37.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73768",
    "data-name": "Group 73768",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66119",
    "data-name": "Path 66119",
    d: "M23.672,48.226l-.266-.155a.288.288,0,0,1-.072-.061l.266.155a.274.274,0,0,0,.072.061",
    transform: "translate(-23.241 -47.71)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66120",
    "data-name": "Path 66120",
    d: "M23.784,48.089l-.266-.155a.463.463,0,0,1-.093-.3l.266.155a.458.458,0,0,0,.093.3",
    transform: "translate(-23.424 -47.633)",
    fill: "#a97f7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64918",
    "data-name": "Group 64918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64917",
    "data-name": "Group 64917",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66122",
    "data-name": "Path 66122",
    d: "M22.071,41.034l.266.155a.4.4,0,0,0-.4.038l-.266-.155a.4.4,0,0,1,.4-.038",
    transform: "translate(60.382 -8.302)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64920",
    "data-name": "Group 64920",
    transform: "translate(82.051 32.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73770",
    "data-name": "Group 73770",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66123",
    "data-name": "Path 66123",
    d: "M21.935,41.228l-.266-.155a.4.4,0,0,1,.4-.038l.266.155a.4.4,0,0,0-.4.038",
    transform: "translate(-21.669 -40.997)",
    fill: "#a97f7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64922",
    "data-name": "Group 64922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64921",
    "data-name": "Group 64921",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66125",
    "data-name": "Path 66125",
    d: "M23.817,46.79l-.266-.155-.009-3.93.266.155Z",
    transform: "translate(57.409 -8.648)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66126",
    "data-name": "Path 66126",
    d: "M22.44,41.557l-.266-.155.537-.309.266.154Z",
    transform: "translate(59.341 -8.322)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66127",
    "data-name": "Path 66127",
    d: "M23.112,42.611l-.266-.155a1.246,1.246,0,0,1,.564-.975l.266.155a1.246,1.246,0,0,0-.564.975",
    transform: "translate(58.104 -8.4)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64924",
    "data-name": "Group 64924",
    transform: "translate(80.95 33.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73769",
    "data-name": "Group 73769",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66128",
    "data-name": "Path 66128",
    d: "M23.5,42.683l-.266-.155a1.222,1.222,0,0,1,.255-.691l.266.155a1.216,1.216,0,0,0-.255.691",
    transform: "translate(-23.233 -41.553)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66129",
    "data-name": "Path 66129",
    d: "M23.112,41.92l-.266-.155a1.091,1.091,0,0,1,.309-.285l.266.155a1.059,1.059,0,0,0-.309.285",
    transform: "translate(-22.591 -41.481)",
    fill: "#a97f7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64926",
    "data-name": "Group 64926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64925",
    "data-name": "Group 64925",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66131",
    "data-name": "Path 66131",
    d: "M22.55,41.267c.312-.179.567-.034.568.323l.009,3.931a1.243,1.243,0,0,1-.563.975l-.537.31c-.31.179-.566.034-.568-.324l-.008-3.93a1.243,1.243,0,0,1,.563-.975Z",
    transform: "translate(59.766 -8.341)",
    fill: "#f0dbd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66132",
    "data-name": "Path 66132",
    d: "M23.765,53.657,23.5,53.5a.4.4,0,0,1-.165-.362l.266.155a.4.4,0,0,0,.165.362",
    transform: "translate(57.626 -10.761)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64928",
    "data-name": "Group 64928",
    transform: "translate(80.96 42.379)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73767",
    "data-name": "Group 73767",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66133",
    "data-name": "Path 66133",
    d: "M23.672,53.733l-.266-.155a.271.271,0,0,1-.072-.061l.266.155a.274.274,0,0,0,.072.061",
    transform: "translate(-23.241 -53.217)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66134",
    "data-name": "Path 66134",
    d: "M23.784,53.6l-.266-.155a.463.463,0,0,1-.093-.3l.266.155a.458.458,0,0,0,.093.3",
    transform: "translate(-23.424 -53.14)",
    fill: "#a97f7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64930",
    "data-name": "Group 64930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64929",
    "data-name": "Group 64929",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66136",
    "data-name": "Path 66136",
    d: "M22.071,49.178l.266.155a.4.4,0,0,0-.4.038l-.266-.154a.4.4,0,0,1,.4-.039",
    transform: "translate(60.382 -9.951)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64932",
    "data-name": "Group 64932",
    transform: "translate(82.051 39.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64931",
    "data-name": "Group 64931",
    transform: "translate(0)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66137",
    "data-name": "Path 66137",
    d: "M21.935,49.371l-.266-.155a.4.4,0,0,1,.4-.038l.266.155a.4.4,0,0,0-.4.038",
    transform: "translate(-21.669 -49.139)",
    fill: "#a97f7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64934",
    "data-name": "Group 64934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64933",
    "data-name": "Group 64933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66139",
    "data-name": "Path 66139",
    d: "M23.817,52.831l-.266-.155-.009-1.828.266.155Z",
    transform: "translate(57.409 -10.297)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66140",
    "data-name": "Path 66140",
    d: "M22.44,49.7l-.266-.155.537-.309.266.154Z",
    transform: "translate(59.341 -9.971)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66141",
    "data-name": "Path 66141",
    d: "M23.112,50.755l-.266-.155a1.246,1.246,0,0,1,.564-.975l.266.155a1.246,1.246,0,0,0-.564.975",
    transform: "translate(58.104 -10.049)",
    fill: "#f4f4fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64936",
    "data-name": "Group 64936",
    transform: "translate(80.95 39.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64935",
    "data-name": "Group 64935",
    transform: "translate(0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66142",
    "data-name": "Path 66142",
    d: "M23.5,50.827l-.266-.155a1.222,1.222,0,0,1,.255-.691l.266.155a1.216,1.216,0,0,0-.255.691",
    transform: "translate(-23.233 -49.696)",
    fill: "#a97f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66143",
    "data-name": "Path 66143",
    d: "M23.112,50.063l-.266-.155a1.091,1.091,0,0,1,.309-.285l.266.155a1.07,1.07,0,0,0-.309.285",
    transform: "translate(-22.591 -49.624)",
    fill: "#a97f7f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64938",
    "data-name": "Group 64938",
    transform: "translate(81.217 39.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64979",
    "data-name": "Group 64979",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66145",
    "data-name": "Path 66145",
    d: "M22.55,49.41c.312-.179.567-.034.568.323l.009,1.828a1.243,1.243,0,0,1-.563.976l-.537.31c-.31.179-.566.033-.568-.324L21.451,50.7a1.242,1.242,0,0,1,.563-.975Z",
    transform: "translate(-21.451 -49.333)",
    fill: "#f0dbd0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64965",
    "data-name": "Group 64965",
    transform: "translate(19.927 1.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64982",
    "data-name": "Group 64982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66185",
    "data-name": "Path 66185",
    d: "M90.155,88.69l-40.366-23.3V2L90.156,25.3Z",
    transform: "translate(-49.789 -1.999)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24453",
    "data-name": "Rectangle 24453",
    width: 0.317,
    height: 34.921,
    transform: "translate(19.981 30.997)",
    fill: "#35353f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66186",
    "data-name": "Path 66186",
    d: "M85.364,70.387V55.69l-.079-.045L57.99,39.886v14.88h.317V40.435l26.74,15.438V70.387Z",
    transform: "translate(-51.538 -9.671)",
    fill: "#35353f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24454",
    "data-name": "Rectangle 24454",
    width: 19.679,
    height: 0.317,
    transform: "translate(23.57 67.881) rotate(-149.95)",
    fill: "#35353f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66187",
    "data-name": "Path 66187",
    d: "M64.992,25.055c0,5.168,3.628,11.451,8.1,14.034s8.1.49,8.1-4.678-3.628-11.45-8.1-14.034-8.1-.489-8.1,4.678",
    transform: "translate(-52.955 -5.496)",
    fill: "#e3645c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66188",
    "data-name": "Path 66188",
    d: "M76.477,29.73c0,1.148-.794,1.619-1.775,1.053a3.949,3.949,0,0,1-1.774-3.1c0-1.148.794-1.619,1.774-1.053a3.948,3.948,0,0,1,1.775,3.1",
    transform: "translate(-54.562 -6.938)",
    fill: "#ffbcb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66189",
    "data-name": "Path 66189",
    d: "M77.561,38.577V36.982a6.042,6.042,0,0,0-2.7-4.728l-1.046-.6c-1.488-.859-2.7-.137-2.7,1.6v1.595Z",
    transform: "translate(-54.194 -7.93)",
    fill: "#ffbcb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66190",
    "data-name": "Path 66190",
    d: "M68.7,58.192a11.378,11.378,0,0,0,5.147,8.915c2.843,1.641,5.148.311,5.148-2.971a11.376,11.376,0,0,0-5.148-8.915C71,53.579,68.7,54.909,68.7,58.192",
    transform: "translate(-53.706 -12.634)",
    fill: "#7580cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66191",
    "data-name": "Path 66191",
    d: "M75.994,61.162c0,.729-.5,1.029-1.128.669a2.509,2.509,0,0,1-1.127-1.971c0-.729.5-1.028,1.127-.668a2.508,2.508,0,0,1,1.128,1.971",
    transform: "translate(-54.727 -13.55)",
    fill: "#dad8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66192",
    "data-name": "Path 66192",
    d: "M76.682,66.781V65.768a3.836,3.836,0,0,0-1.718-3l-.664-.384c-.945-.545-1.718-.087-1.718,1.019v1.014Z",
    transform: "translate(-54.492 -14.18)",
    fill: "#dad8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66193",
    "data-name": "Path 66193",
    d: "M51.624,68.05a11.378,11.378,0,0,0,5.147,8.915c2.843,1.641,5.148.311,5.148-2.971a11.378,11.378,0,0,0-5.148-8.916c-2.842-1.64-5.147-.31-5.147,2.972",
    transform: "translate(-23.015 -14.631)",
    fill: "#7580cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66194",
    "data-name": "Path 66194",
    d: "M58.92,71.019c0,.729-.5,1.029-1.128.669a2.508,2.508,0,0,1-1.127-1.971c0-.73.5-1.029,1.127-.669a2.508,2.508,0,0,1,1.128,1.971",
    transform: "translate(-24.036 -15.546)",
    fill: "#dad8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66195",
    "data-name": "Path 66195",
    d: "M59.608,76.639V75.626a3.836,3.836,0,0,0-1.718-3l-.664-.384c-.945-.545-1.718-.087-1.718,1.019v1.014Z",
    transform: "translate(-23.802 -16.177)",
    fill: "#dad8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66196",
    "data-name": "Path 66196",
    d: "M85.662,48.4a11.378,11.378,0,0,0,5.147,8.915c2.843,1.641,5.148.311,5.148-2.971a11.377,11.377,0,0,0-5.148-8.916c-2.842-1.641-5.147-.31-5.147,2.972",
    transform: "translate(-84.198 -10.651)",
    fill: "#7580cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66197",
    "data-name": "Path 66197",
    d: "M92.958,51.368c0,.729-.5,1.029-1.128.669A2.509,2.509,0,0,1,90.7,50.066c0-.729.5-1.028,1.127-.668a2.508,2.508,0,0,1,1.128,1.971",
    transform: "translate(-85.219 -11.567)",
    fill: "#dad8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66198",
    "data-name": "Path 66198",
    d: "M93.646,56.987V55.974a3.836,3.836,0,0,0-1.718-3l-.664-.384c-.945-.545-1.718-.087-1.718,1.019V54.62Z",
    transform: "translate(-84.985 -12.197)",
    fill: "#dad8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66199",
    "data-name": "Path 66199",
    d: "M68.7,80.116a11.378,11.378,0,0,0,5.147,8.915c2.843,1.641,5.148.311,5.148-2.971a11.378,11.378,0,0,0-5.148-8.916C71,75.5,68.7,76.833,68.7,80.116",
    transform: "translate(-53.706 -17.074)",
    fill: "#9bb161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66200",
    "data-name": "Path 66200",
    d: "M75.994,83.086c0,.729-.5,1.029-1.128.669a2.509,2.509,0,0,1-1.127-1.971c0-.729.5-1.028,1.127-.668a2.508,2.508,0,0,1,1.128,1.971",
    transform: "translate(-54.727 -17.99)",
    fill: "#dceaaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66201",
    "data-name": "Path 66201",
    d: "M76.682,88.706V87.693a3.836,3.836,0,0,0-1.718-3l-.664-.384c-.945-.545-1.718-.087-1.718,1.019v1.014Z",
    transform: "translate(-54.492 -18.62)",
    fill: "#dceaaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66202",
    "data-name": "Path 66202",
    d: "M85.662,70.322a11.378,11.378,0,0,0,5.147,8.915c2.843,1.641,5.148.311,5.148-2.971a11.377,11.377,0,0,0-5.148-8.915c-2.842-1.641-5.147-.311-5.147,2.971",
    transform: "translate(-84.198 -15.091)",
    fill: "#9bb161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66203",
    "data-name": "Path 66203",
    d: "M92.958,73.292c0,.729-.5,1.029-1.128.669A2.508,2.508,0,0,1,90.7,71.99c0-.73.5-1.029,1.127-.669a2.508,2.508,0,0,1,1.128,1.971",
    transform: "translate(-85.219 -16.006)",
    fill: "#dceaaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66204",
    "data-name": "Path 66204",
    d: "M93.646,78.912V77.9a3.836,3.836,0,0,0-1.718-3l-.664-.384c-.945-.545-1.718-.087-1.718,1.019v1.014Z",
    transform: "translate(-84.985 -16.637)",
    fill: "#dceaaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66227",
    "data-name": "Path 66227",
    d: "M38.836,43c0,1.3-.907,1.837-2.026,1.191a4.5,4.5,0,0,1-2.025-3.53c0-1.3.907-1.836,2.025-1.191A4.5,4.5,0,0,1,38.836,43",
    transform: "translate(13.495 -9.531)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66228",
    "data-name": "Path 66228",
    d: "M40.073,53.049V51.237a6.875,6.875,0,0,0-3.086-5.377l-1.193-.689c-1.7-.98-3.085-.163-3.085,1.814V48.8Z",
    transform: "translate(13.916 -10.657)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66229",
    "data-name": "Path 66229",
    d: "M30.542,48.4l-.593-.343v.979l-.782-.451v.654l.782.451v1.022l.593.343V50.03l.779.45v-.654l-.779-.45Z",
    transform: "translate(25.492 -11.325)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66230",
    "data-name": "Path 66230",
    d: "M38.836,64.927c0,1.3-.907,1.837-2.026,1.191a4.5,4.5,0,0,1-2.025-3.529c0-1.3.907-1.837,2.025-1.191a4.5,4.5,0,0,1,2.026,3.529",
    transform: "translate(13.495 -13.972)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66231",
    "data-name": "Path 66231",
    d: "M40.073,74.979V73.167a6.877,6.877,0,0,0-3.086-5.378L35.793,67.1c-1.7-.98-3.085-.163-3.085,1.814v1.812Z",
    transform: "translate(13.916 -15.098)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66232",
    "data-name": "Path 66232",
    d: "M30.542,70.327l-.593-.343v.979l-.782-.451v.654l.782.451v1.022l.593.343V71.96l.779.45v-.654l-.779-.45Z",
    transform: "translate(25.492 -15.766)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66233",
    "data-name": "Path 66233",
    d: "M38.836,86.857c0,1.3-.907,1.837-2.026,1.191a4.5,4.5,0,0,1-2.025-3.529c0-1.3.907-1.837,2.025-1.191a4.5,4.5,0,0,1,2.026,3.529",
    transform: "translate(13.495 -18.413)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66234",
    "data-name": "Path 66234",
    d: "M40.073,96.909V95.1a6.875,6.875,0,0,0-3.086-5.378l-1.193-.689c-1.7-.98-3.085-.163-3.085,1.814v1.812Z",
    transform: "translate(13.916 -19.539)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66235",
    "data-name": "Path 66235",
    d: "M30.542,92.257l-.593-.343v.979l-.782-.451V93.1l.782.451v1.022l.593.343V93.89l.779.45v-.654l-.779-.45Z",
    transform: "translate(25.492 -20.207)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66236",
    "data-name": "Path 66236",
    d: "M38.836,108.787c0,1.3-.907,1.837-2.026,1.191a4.5,4.5,0,0,1-2.025-3.529c0-1.3.907-1.837,2.025-1.191a4.5,4.5,0,0,1,2.026,3.53",
    transform: "translate(13.495 -22.854)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66237",
    "data-name": "Path 66237",
    d: "M40.073,118.839v-1.812a6.875,6.875,0,0,0-3.086-5.377l-1.193-.689c-1.7-.98-3.085-.163-3.085,1.814v1.812Z",
    transform: "translate(13.916 -23.98)",
    fill: "#fcedd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66238",
    "data-name": "Path 66238",
    d: "M30.542,114.187l-.593-.343v.979l-.782-.451v.654l.782.451V116.5l.593.343V115.82l.779.45v-.654l-.779-.45Z",
    transform: "translate(25.492 -24.648)",
    fill: "#fcedd7"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73797",
    "data-name": "Group 73797",
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 1338.522, 787.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73796",
    "data-name": "Group 73796",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73795",
    "data-name": "Group 73795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73794",
    "data-name": "Group 73794",
    clipPath: "url(#clip-path-15)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_80599",
    "data-name": "Path 80599",
    d: "M35.794,35.993c-.048.147-.152.392-.229.412s-.36.125-.36.125a.686.686,0,0,1-.076.385.818.818,0,0,1-.357.253c-.088.018-.316.041-.316.041s-.021.312-.25.359a1.992,1.992,0,0,1-.638-.044.568.568,0,0,1-.515.18.758.758,0,0,1-.236-.078l0,0a1.457,1.457,0,0,1-.387-.3s-.523-.291-.985-.553c-.333-.187-.632-.363-.681-.4a7.112,7.112,0,0,0-.9-.55c-.076-.006-2.5-.6-2.791-.707s-2.594-.629-2.806-1.019a7.625,7.625,0,0,1-.5-1.332c-.324-1.182-.416-2.683,1.217-2.56,0,0,2.532,1.531,3.141,1.816s3.152,1.662,3.245,1.768,2.054.253,2.38.464a16.4,16.4,0,0,1,1.708,1.109c.149.2.393.491.345.639",
    transform: "translate(-7.263 -9.305)",
    fill: "#fac7a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73787",
    "data-name": "Group 73787",
    transform: "translate(16.494 22.328)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73786",
    "data-name": "Group 73786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73785",
    "data-name": "Group 73785",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80600",
    "data-name": "Path 80600",
    d: "M31.526,37.41c-.333-.187-.632-.363-.682-.4a7.017,7.017,0,0,0-.9-.55c-.076-.006-2.5-.6-2.791-.707s-2.594-.629-2.806-1.019a7.6,7.6,0,0,1-.5-1.332l.392-1.124A8.283,8.283,0,0,0,25.673,34.6,23.122,23.122,0,0,0,28.9,35.892c.513.117,1.635.329,1.846.678a5.007,5.007,0,0,0,.779.839",
    transform: "translate(-23.843 -32.275)",
    fill: "#fad3be"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73790",
    "data-name": "Group 73790",
    transform: "translate(23.49 25.416)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73789",
    "data-name": "Group 73789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73788",
    "data-name": "Group 73788",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80601",
    "data-name": "Path 80601",
    d: "M37.654,37.767s-.444-.149-.534-.037a.971.971,0,0,0-.126.379l.663.321.458.149-.4-.027-.735-.235-.486-.393s-.378-.084-.391-.01a.944.944,0,0,0,.03.262l.914.858.653.121-.5-.035-.631-.212-.764-.93s-.3.07-.307.2.506.571.506.571l.493.494.833.308-.4-.027c-.024,0-.751-.3-.751-.3l-.775-.782a.235.235,0,0,0-.2.214c-.024.191.506.679.506.679l.3.3a1.457,1.457,0,0,1-.387-.3s-1.549-.859-1.667-.955c0,0-.08-.868.349-.9s1.044.156,1.5.1a.757.757,0,0,0,.607-.393s-.264-.572.253-.437a8.838,8.838,0,0,1,1.275.464c.036.027,1.444,1.238-.291.543",
    transform: "translate(-33.955 -36.739)",
    fill: "#fad3be"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80602",
    "data-name": "Path 80602",
    d: "M36.77,36.62c-.071-.1-.152-.238-.3-.159-.026.015-.049.035-.075.05a.473.473,0,0,1-.256.044,2.154,2.154,0,0,1-.681-.1,3.151,3.151,0,0,1-.478-.24,1.723,1.723,0,0,0-.448-.2c-.031-.008-.072-.034-.053-.059a.052.052,0,0,1,.021-.015,4.541,4.541,0,0,1,1.691-.507,10.282,10.282,0,0,1,1.684.894c.425.264.877.787.806.908a.6.6,0,0,1-.7.2,2.671,2.671,0,0,1-.843-.476,1.858,1.858,0,0,1-.361-.338",
    transform: "translate(-10.624 -10.921)",
    fill: "#fad3b5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80603",
    "data-name": "Path 80603",
    d: "M18.058,88.32A12.277,12.277,0,0,1,20.1,90.578a1.712,1.712,0,0,1,.438,1.3,1.1,1.1,0,0,1-.533.686,1.8,1.8,0,0,1-.857.216,3.234,3.234,0,0,1-1.754-.518,5.7,5.7,0,0,1-1.364-1.242,4.293,4.293,0,0,0-.871-.9,4.642,4.642,0,0,0-1.428-.489,2.051,2.051,0,0,1-1.145-.612,2.236,2.236,0,0,1-.261-1.19,3.156,3.156,0,0,1,.974-2.3c-.059.055.072.364.114.414.136.158.281.053.452.006a3.19,3.19,0,0,1,1.218-.141,1.021,1.021,0,0,1,.732.268c.5.484,1.975,2.023,2.247,2.249",
    transform: "translate(-3.797 -26.359)",
    fill: "#4c2539"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80604",
    "data-name": "Path 80604",
    d: "M12.414,69.489a47.346,47.346,0,0,1-.134-6.082c.037-.688.1-1.375.181-2.059a17.679,17.679,0,0,0,.333-2.492q-.028-1.467-.055-2.933-.073-3.825-.145-7.649a7.993,7.993,0,0,1,.1-1.759,5.614,5.614,0,0,1,.815-1.874,5.234,5.234,0,0,1,1.438-1.562,2.532,2.532,0,0,0,1.191-1.366c.139-.45.176-.924.3-1.377a11.332,11.332,0,0,1,1.714,4.275,31.362,31.362,0,0,1,.74,8.038,55.358,55.358,0,0,1-1.184,8.558c-.415,2.115-.961,9.737-1.262,11.383-.059.324-.152.407-.482.524a2.575,2.575,0,0,1-1.173.107,5,5,0,0,1-1.555-.519c-.295-.145-.56-.326-.6-.67-.034-.309-.183-2-.224-2.543",
    transform: "translate(-3.77 -12.432)",
    fill: "#4d3644"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80605",
    "data-name": "Path 80605",
    d: "M10.4,92.83a18.629,18.629,0,0,1,1.627,2.356,2.755,2.755,0,0,1,.372,1.022,1.164,1.164,0,0,1-.339,1,1.551,1.551,0,0,1-1.135.266,5.61,5.61,0,0,1-2.266-.649,2.8,2.8,0,0,1-1.245-1.162A9.481,9.481,0,0,0,6.9,94.371c-.366-.528-1.077-.744-1.415-1.29a1.8,1.8,0,0,1-.228-.946,2.605,2.605,0,0,1,.7-1.836,1.879,1.879,0,0,1,1.85-.5c.549.175.881.808,1.213,1.241L10.4,92.83",
    transform: "translate(-1.62 -27.652)",
    fill: "#4c2539"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80606",
    "data-name": "Path 80606",
    d: "M4.284,61.266a26.3,26.3,0,0,0-.66-3.058q-.793-3.182-1.331-6.42A19.7,19.7,0,0,1,3.464,41.71a5.378,5.378,0,0,1,.781-1.54.991.991,0,0,1,.65-.424c.5-.039.516.573.717.884A4.14,4.14,0,0,0,7.549,42.2a8.35,8.35,0,0,0,3.792.386c.443-.035.836.093,1.265.093.156,0,1.009-.2.983-.409a8.116,8.116,0,0,1-.952,4.528c-.113.229-.234.454-.36.677-.313.556-.661,1.094-1.018,1.623a7.419,7.419,0,0,0-1.075,1.567,6.885,6.885,0,0,0,.066,1.777c.014.677.006,1.353-.021,2.029-.075,1.9-.293,3.8-.558,5.685-.237,1.687-.733,3.315-.975,5-.091.637-.14,1.281-.186,1.923-.206,2.847-.389,5.7-.419,8.551a.522.522,0,0,1-.061.295.493.493,0,0,1-.249.163,4.855,4.855,0,0,1-3.193.086.442.442,0,0,1-.152-.073.48.48,0,0,1-.1-.414c.236-3.2-1.157-6.392-.71-9.57.11-.784.4-1.5.57-2.266a7.543,7.543,0,0,0,.082-2.581",
    transform: "translate(-0.637 -12.249)",
    fill: "#5c454e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80607",
    "data-name": "Path 80607",
    d: "M23.437,18.578a4.411,4.411,0,0,1,.162.654,32.857,32.857,0,0,1,.391,3.692c.042.607.34,2.944.312,3.5a2.832,2.832,0,0,1-.113.585,6.27,6.27,0,0,1-.354,1.062,4.89,4.89,0,0,1-1.322,1.586.22.22,0,0,1-.114.062c-.093.01-.155-.093-.191-.178a38.926,38.926,0,0,1-1.654-4.466,14.041,14.041,0,0,1-.583-4.7c.073-1.141.468-2.36.028-3.469a6.02,6.02,0,0,1,2.134.443,2.414,2.414,0,0,1,1.034.707,1.863,1.863,0,0,1,.27.519",
    transform: "translate(-6.148 -5.211)",
    fill: "#5974b2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80608",
    "data-name": "Path 80608",
    d: "M17.234,18.677c.047.283.082.569.116.854l.042.366c.153,1.357.277,2.717.392,4.078.055.653.129,1.282.233,1.927a12.611,12.611,0,0,1,.21,2.006,4.359,4.359,0,0,1-.506,2.125,3.854,3.854,0,0,1-.669.8,8.934,8.934,0,0,0-.692.879,10.973,10.973,0,0,0-.841,1.288,3.5,3.5,0,0,0-.4,2.021q.1,1.064.2,2.128a1.3,1.3,0,0,1,0,.38,1.016,1.016,0,0,1-.221.422A4.273,4.273,0,0,1,12.438,39.2c-3.061.57-6.357.589-9.141-.805a1.609,1.609,0,0,1-.556-.4c-.4-.5-.14-1.238.133-1.819l.9-1.9a3.53,3.53,0,0,0,.351-.992,4.239,4.239,0,0,0-.082-1.191c-.127-.876-.144-1.763-.217-2.645a20.724,20.724,0,0,0-.512-3.163q-.192-.794-.446-1.57a2.447,2.447,0,0,1,.01-1.726,4.22,4.22,0,0,1,.7-1.009,25.77,25.77,0,0,1,2.587-2.614,11.583,11.583,0,0,1,3.669-2.324A13.354,13.354,0,0,1,12.17,16.5c.765-.123,1.529-.2,2.3-.243a2.8,2.8,0,0,1,1.717.252,2.6,2.6,0,0,1,.9,1.5c.058.218.1.439.14.661",
    transform: "translate(-0.781 -5.005)",
    fill: "#708dd0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80609",
    "data-name": "Path 80609",
    d: "M20.2,22.9a42.952,42.952,0,0,1-.365,8.884q-.244,1.914-.3,3.844c-.018.643.033,3.021.1,3.562a.043.043,0,0,0,.008.023.045.045,0,0,0,.033.012,1.53,1.53,0,0,0,1.4-.722.865.865,0,0,0,.141-.292,1,1,0,0,0-.077-.324,7.442,7.442,0,0,1,.329-4.621c.344-.836.872-1.583,1.219-2.415a7.732,7.732,0,0,0,.855-2.064,8.8,8.8,0,0,0-.055-2.013q-.128-1.229-.256-2.457c-.129-1.246-.259-2.492-.435-3.732-.15-1.055-.164-2.563-.827-3.439-.805-1.064-2.168-1.036-3.364-1.058A22.286,22.286,0,0,1,20.2,22.9",
    transform: "translate(-5.736 -4.958)",
    fill: "#f46c08"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80610",
    "data-name": "Path 80610",
    d: "M10.376,21.316c-.367-.69-.953-1.25-1.292-1.955a3.243,3.243,0,0,1-.208-2.222l-.051.627A.891.891,0,0,0,9,16.954a22.236,22.236,0,0,0-5.031,4.021,4.624,4.624,0,0,0-1.02,1.467,4.961,4.961,0,0,0-.208,1.869c.079,3.579.464,7.191-.154,10.717C2.4,36.122,2.113,37.2,2,38.306a1.2,1.2,0,0,0,.035.549,1.188,1.188,0,0,0,.389.462A8.16,8.16,0,0,0,9.2,40.957,145.808,145.808,0,0,0,10.9,24.809a6.928,6.928,0,0,0-.529-3.493",
    transform: "translate(-0.613 -5.225)",
    fill: "#f46c08"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80611",
    "data-name": "Path 80611",
    d: "M15.76,19.053a1.517,1.517,0,0,1-.053.182.371.371,0,0,1-.077.141c-.086.088-.252.051-.36.042-.144-.012-.287-.031-.43-.057a4.974,4.974,0,0,1-.838-.23,5.475,5.475,0,0,1-1.515-.859c-.046-.036-.091-.073-.135-.111a3.571,3.571,0,0,1-.751-.843,2.827,2.827,0,0,1-.3-.714.36.36,0,0,1-.018-.129.4.4,0,0,1,.053-.143c.755-1.438.8-3.2,1.708-4.546.027.163.053.326.08.489a3.423,3.423,0,0,0,.28,1.028,2.382,2.382,0,0,0,1.459,1.1,6.748,6.748,0,0,0,1.391.229,1.464,1.464,0,0,0,.621-.014,3.241,3.241,0,0,0,.615-.279,5.841,5.841,0,0,1-.159,1.157c-.1.532-.228,1.061-.354,1.587q-.06.249-.122.5c-.038.153-.053.311-.244.324a1.787,1.787,0,0,1-.38-.013.537.537,0,0,0-.163-.008.318.318,0,0,0-.23.233,1.129,1.129,0,0,0-.024.342,2.456,2.456,0,0,1-.052.591",
    transform: "translate(-3.476 -3.633)",
    fill: "#ffb680"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80612",
    "data-name": "Path 80612",
    d: "M18.873,22.267a6.912,6.912,0,0,0,.488-1.5,4.1,4.1,0,0,0-.251-2.266,1.163,1.163,0,0,1-.413.9,3.086,3.086,0,0,1-.731.461c-.177.09-.134.107.024.17.45.181.926,2.127.883,2.23",
    transform: "translate(-5.502 -5.702)",
    fill: "#fcebd8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80613",
    "data-name": "Path 80613",
    d: "M12.645,17.5a7.776,7.776,0,0,0,1.632.9,7.572,7.572,0,0,0,1.661.562q-.161,1.191-.322,2.383a9.764,9.764,0,0,1-1.972-.675c-.495-.223-1.039-.534-1.508-.807A3.664,3.664,0,0,1,10.924,18.8a1.2,1.2,0,0,1-.214-.5,1.546,1.546,0,0,1,.169-.782,1.638,1.638,0,0,0,.174-.722,7.379,7.379,0,0,1-.165-.807.676.676,0,0,1,.3-.524.283.283,0,0,1,.126-.051c.284-.028.23.327.219.49a1.1,1.1,0,0,0,.187.544,3.375,3.375,0,0,0,.927,1.054",
    transform: "translate(-3.298 -4.751)",
    fill: "#fcebd8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80614",
    "data-name": "Path 80614",
    d: "M12.217,4.5a4.309,4.309,0,0,1,.814-.834,4.071,4.071,0,0,1,1.087-.537A4.332,4.332,0,0,1,16.5,3.069a4.4,4.4,0,0,1,2.448,1.745A6.833,6.833,0,0,1,19.871,9.2a12.431,12.431,0,0,1-1.006,4.012,1.256,1.256,0,0,1-.275.449,1.015,1.015,0,0,1-.592.227,4.139,4.139,0,0,1-1.541-.223,13.006,13.006,0,0,1-2.513-.946c-.4-.21-.827-.529-.839-.981,0-.13.024-.277-.062-.376a.4.4,0,0,0-.152-.094,2.662,2.662,0,0,1-.962-.463A2.56,2.56,0,0,1,11.294,9.8a4.865,4.865,0,0,1-.206-1.813A5.818,5.818,0,0,1,12.217,4.5",
    transform: "translate(-3.415 -0.903)",
    fill: "#ffcfa6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80615",
    "data-name": "Path 80615",
    d: "M17.387,4.723a.416.416,0,0,0-.163,0A.464.464,0,0,0,17,4.9a4.871,4.871,0,0,1-1.866,1.15A2.9,2.9,0,0,0,13.5,7.46c-.192.5-.163,1.129-.585,1.454a2.167,2.167,0,0,0-.724-.827.738.738,0,0,0-.6-.154A.722.722,0,0,0,11.2,8.7a2.48,2.48,0,0,0,1.624,1.974.838.838,0,0,1,.351.213.739.739,0,0,1,.089.546,11.629,11.629,0,0,1-.3,1.666,3.934,3.934,0,0,1-3.245-1.739A2.031,2.031,0,0,1,9.4,10.74a2.457,2.457,0,0,1-.034-.872q.094-1.126.267-2.242a10.922,10.922,0,0,1,.8-2.964,4.725,4.725,0,0,1,2.025-2.248A4.291,4.291,0,0,1,14.19,1.9a4.994,4.994,0,0,1,4.293,1.956c.152.2.527.758.28,1-.16.154-.32.042-.491.015-.3-.046-.59-.1-.885-.143",
    transform: "translate(-2.879 -0.582)",
    fill: "#691414"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80616",
    "data-name": "Path 80616",
    d: "M9.937,5.662l.028-.43.357-.028,0,.033,4.16-2.05a1.628,1.628,0,0,1,1.186-.036h0l.012,0a1.264,1.264,0,0,1,.136.059A20.478,20.478,0,0,1,21.16,7.051l.307.065-.029.431a.418.418,0,0,1-.048.171h0s-1.06,2.136-4.476,2.157h0a2,2,0,0,1-.7-.106h0S10.146,7.634,9.941,5.746a.315.315,0,0,1,0-.08v0Z",
    transform: "translate(-3.062 -0.942)",
    fill: "#f46c08"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80617",
    "data-name": "Path 80617",
    d: "M9.979,5.023a.513.513,0,0,1,.329-.4l4.214-2.077a1.628,1.628,0,0,1,1.186-.036h0l.012,0a1.2,1.2,0,0,1,.136.059,20.63,20.63,0,0,1,5.417,3.909.761.761,0,0,1,.075.075l0,0h0a.449.449,0,0,1,.082.518h0s-1.06,2.136-4.476,2.157h0a2.018,2.018,0,0,1-.7-.106h0s-6.07-2.136-6.275-4.023a.351.351,0,0,1-.006-.08v0Z",
    transform: "translate(-3.075 -0.745)",
    fill: "#fa9238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80618",
    "data-name": "Path 80618",
    d: "M10.644,4.07a2.426,2.426,0,0,0,1.205,1.69,7.174,7.174,0,0,0,6.479.414,2.466,2.466,0,0,0,1.435-1.531,4.573,4.573,0,0,0-.1-1.022h0a4.573,4.573,0,0,0-9.02.45",
    transform: "translate(-3.281 0)",
    fill: "#f46c08"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80619",
    "data-name": "Path 80619",
    d: "M15.793.844c-.4.794.287,1.943,1.53,2.567S19.9,3.9,20.3,3.1s-.287-1.943-1.53-2.567S16.191.05,15.793.844",
    transform: "translate(-4.833 -0.045)",
    fill: "#fa9238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80620",
    "data-name": "Path 80620",
    d: "M21.348,45.412l-4.274-2.468a.958.958,0,0,1,0-1.659L25.189,36.6a3.254,3.254,0,0,1,3.254,0l3.968,2.291a.836.836,0,0,1,0,1.448l-8.786,5.075a2.279,2.279,0,0,1-2.278,0",
    transform: "translate(-5.115 -11.145)",
    fill: "#5b3439"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80621",
    "data-name": "Path 80621",
    d: "M21.3,44.98l-4.422-2.553a.859.859,0,0,1,0-1.488l8.264-4.773a3.254,3.254,0,0,1,3.254,0l3.968,2.291a.836.836,0,0,1,0,1.448L23.582,44.98a2.279,2.279,0,0,1-2.278,0",
    transform: "translate(-5.071 -11.012)",
    fill: "#f8dbc9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80622",
    "data-name": "Path 80622",
    d: "M22.75,44.242l-3.864-2.23a.438.438,0,0,1,0-.819l7.237-4.18a1.669,1.669,0,0,1,1.668,0l3.864,2.231c.378.218.464.992.086,1.21l-7.323,3.788a1.668,1.668,0,0,1-1.669,0",
    transform: "translate(-5.734 -11.339)",
    fill: "#5b3439"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80623",
    "data-name": "Path 80623",
    d: "M22.75,44.9,18.886,42.67a.566.566,0,0,1,0-.98l7.237-4.18a1.667,1.667,0,0,1,1.668,0l3.864,2.23a.566.566,0,0,1,0,.98L24.418,44.9a1.668,1.668,0,0,1-1.669,0",
    transform: "translate(-5.734 -11.492)",
    fill: "#583d70"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80624",
    "data-name": "Path 80624",
    d: "M5.171,33.574s-.091.3-.214.7l0,.007c-.19.621-.458,1.485-.6,1.9a20.041,20.041,0,0,0-.471,2.529c-.013.094-.019.149-.019.149s-1.483,1.717-2.252,1.717a2.6,2.6,0,0,0-.457.053c-.122.011.07.874-.44.243A7.835,7.835,0,0,1,.1,37.751c.146-.93.9-5.166.9-5.166s2.98-.863,3.9.2a1.157,1.157,0,0,1,.27.788",
    transform: "translate(-0.024 -9.941)",
    fill: "#fccdaa"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80625",
    "data-name": "Path 80625",
    d: "M16.519,47.539c-.12.183-1.536.2-1.536.2s-.338.267-.493.254a17.43,17.43,0,0,1-1.658.786c-.532.1-.333.024-.7-.181s-2.1-1.366-2.286-1.47-4.68-1.043-5.94-1.622-2.982-1.72-2.9-2.055a2.491,2.491,0,0,1,.137-.376,4.484,4.484,0,0,1,.942-1.426,4.052,4.052,0,0,1,2-.529s.561.152.854.207h0c.292.052,2.372,1.884,2.787,2.129a14.21,14.21,0,0,0,2.863.844,9.934,9.934,0,0,0,1.2-.1,2.539,2.539,0,0,1,1.076.293l1.79,1.558-.318.139h0l-.353.154.57.291s1.775.275,1.88.284c.066.006.134.181.142.354a.46.46,0,0,1-.054.264",
    transform: "translate(-0.309 -12.674)",
    fill: "#fccdaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_73793",
    "data-name": "Group 73793",
    transform: "translate(11.3 32.473)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_73792",
    "data-name": "Group 73792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73791",
    "data-name": "Group 73791",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80626",
    "data-name": "Path 80626",
    d: "M16.692,47.318l-.358-.378,1.332.653s-.086-.085.416-.062l-.349.132Z",
    transform: "translate(-16.334 -46.94)",
    fill: "#fad3be"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80627",
    "data-name": "Path 80627",
    d: "M21.823,49.719l.065-.253a.449.449,0,0,1-.065.253",
    transform: "translate(-6.726 -15.246)",
    fill: "#ffe39f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80628",
    "data-name": "Path 80628",
    d: "M2.063,25.483a3.343,3.343,0,0,1,.666-.888,1.13,1.13,0,0,1,1.563.055,3.089,3.089,0,0,1,.767,1.167,8.371,8.371,0,0,1,.4,4.472c-.1.642-.3,1.379-.414,2.017-.246,1.384-.092,2.558-.386,3.847-.027.118-.475.213-.475.213s-.539.1-.727.132c-.338.059-.877.137-1.22.161a2.93,2.93,0,0,1-2.039-.432c-.371-.292-.259-.9-.193-1.3.091-.55,1.45-7.661,1.528-7.967a8.208,8.208,0,0,1,.315-1,4.9,4.9,0,0,1,.219-.475",
    transform: "translate(0 -7.491)",
    fill: "#708dd0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUsers);
export default __webpack_public_path__ + "static/media/ManageUsers.9a159b3bda9031c692e63cee24b0a231.svg";
export { ForwardRef as ReactComponent };